<template>
  <div class="tech-demand-detail">
    <achiTitle title="技术需求详情" subtitle="展示需求完整信息，助力精准对接解决方案" />

    <!-- 核心详情内容 -->
    <div class="detail-content">
      <!-- 1. 标题与类型区 -->
      <div class="header-section">
        <h1 class="demand-name">{{ showData.demandName || '未命名需求' }}</h1>
        <div class="type-tags">
          <el-tag 
            type="primary"
            v-for="(type, index) in getDemandTypeList(showData.demandTypes)"
            :key="index"
          >
            {{ type }}
          </el-tag>
        </div>
      </div>

      <!-- 2. 基础信息区 -->
      <div class="basic-info-section">
        <el-card shadow="hover" class="basic-card">
          <!-- 第一行：技术领域 + 需求状态 -->
          <div class="info-row">
            <div class="info-item with-icon">
              <el-icon :size="20">
                <Coordinate />
              </el-icon>
              <span class="info-label">技术领域</span>
              <span class="info-value">{{ showData.techField || '未指定' }}</span>
            </div>
         
          </div>

          <!-- 第二行：需求类型（多类型展示） -->
          <div class="info-row">
            <div class="info-item with-icon full-width">
              <el-icon :size="20">
                <Money />
              </el-icon>
              <span class="info-label">需求类型</span>
              <span class="info-value">
                {{ showData.demandTypes ? showData.demandTypes.split(',').join('、') : '未分类' }}
              </span>
            </div>
          </div>

          <!-- 第三行：期望完成时间 -->
          <div class="info-row">
            <div class="info-item with-icon full-width">
              <el-icon :size="20">
                <Clock />
              </el-icon>
              <span class="info-label">截止日期</span>
              <span class="info-value">{{ showData.deadline || '未填写' }}</span>
            </div>
          </div>
        </el-card>
      </div>

      <!-- 3. 联系人与对接区 -->
      <div class="contact-section">
        <el-card shadow="hover" class="contact-card">
          <div slot="header" class="card-header">
            <i class="el-icon-user mr-2"></i>对接信息
          </div>
          <div class="contact-content">
            <div class="contact-item with-icon">
              <el-icon :size="20">
                <User />
              </el-icon>
              <span class="contact-label">联系人：</span>
              <span class="contact-value">{{ showData.contactPerson || '未填写' }}</span>
            </div>
            <div class="contact-item with-icon">
              <el-icon :size="20">
                <Phone />
              </el-icon>
              <span class="contact-label">联系方式：</span>
              <span class="contact-value">{{ showData.contactPhone || '未填写' }}</span>
            </div>
          </div>
        </el-card>
      </div>

      <!-- 4. 需求详情区 -->
      <div class="description-section">
        <el-card shadow="hover" class="description-card">
          <div slot="header" class="card-header">
            <i class="el-icon-document mr-2"></i>需求描述
          </div>
          <div class="description-content">
            {{ showData.demandDesc || '暂无详细描述' }}
          </div>
        </el-card>
      </div>
      <!-- 科技创新细分需求 -->
      <div class="description-section">
        <el-card shadow="hover" class="description-card">
          <div slot="header" class="card-header">
            <i class="el-icon-document mr-2"></i>科技创新细分需求
          </div>
          <div class="description-content">
            {{ showData.techInnovationSubDemand || '暂无详细描述' }}
          </div>
        </el-card>
      </div>

    <!-- 公司简介 -->
      <div class="description-section">
        <el-card shadow="hover" class="description-card">
          <div slot="header" class="card-header">
            <i class="el-icon-document mr-2"></i>公司简介
          </div>
          <div class="description-content">
            {{ showData.companyIntro || '暂无详细描述' }}
          </div>
        </el-card>
      </div>

      <!-- 返回按钮 -->
      <div class="back-section">
        <el-button type="default" @click="$router.go(-1)" icon="el-icon-arrow-left">
          返回列表
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import achiTitle from '../components/achievement/achi_title.vue';
import demandApi from '@/api/demands.js';


export default {
  name: 'TechDemandDetail',
  components: {
    achiTitle,
  },
  data() {
    return {
      showData: {}, // 存储需求详情数据
      loading: false,
      error: null
    };
  },
  props: {
    id: {
      type: [String, Number],
      required: true
    }
  },
  methods: {
    // 加载需求详情数据
    async loadData() {
      try {
        this.loading = true;
        // 优先使用props.id，兼容路由参数
        const demandId = this.id || this.$route.params.id;
        // 调用后端接口获取单条需求详情（需后端提供/getById接口）
        const res = await demandApi.getById(demandId);
        this.showData = res.data || {};
        console.log('需求详情数据:', this.showData);
      } catch (err) {
        this.error = '数据加载失败，请刷新页面重试';
        console.error('加载需求详情出错:', err);
      } finally {
        this.loading = false;
      }
    },
    // 解析需求类型为数组（复用列表页逻辑）
    getDemandTypeList(demandTypes) {
      if (!demandTypes || typeof demandTypes !== 'string') return ['未知类型'];
      return demandTypes.split(",").map(type => type.trim()).filter(type => type);
    }
  },
  created() {
    // 组件创建时加载数据
    this.loadData();
    console.log('当前需求ID:', this.id || this.$route.params.id);
  }
};
</script>

<style scoped>
/* 全局容器（与成果详情页保持一致） */
.tech-demand-detail {
  max-width: 80%;
  margin: 30px auto;
  padding: 0 20px;
  font-family: "Microsoft YaHei", sans-serif;
}

/* 详情内容区（复用成果详情页样式） */
.detail-content {
  background: #fff;
  border-radius: 8px;
  padding: 28px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
}

/* 标题区 */
.header-section {
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid #f0f0f0;
}

.demand-name {
  font-size: 24px;
  font-weight: 600;
  color: #1f2d3d;
  margin: 0 0 16px 0;
  line-height: 1.5;
}

/* 类型标签组 */
.type-tags {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

/* 基础信息区 */
.basic-info-section {
  margin-bottom: 24px;
}

.basic-card {
  border-radius: 8px;
  padding: 20px;
}

/* 信息行布局（复用成果详情页逻辑） */
.info-row {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 16px;
  align-items: center;
}

.info-item.with-icon {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 16px;
  border-radius: 6px;
  flex: 1;
  min-width: 280px;
}

.info-item.full-width {
  flex: 100%;
  min-width: 100%;
}

.info-label {
  color: #86909c;
  font-weight: 500;
  min-width: 90px;
  font-size: 18px;
}

.info-value {
  color: #1f2d3d;
  font-weight: 400;
  line-height: 1.5;
  font-size: 18px;
  flex: 1;
}

/* 对接信息区 */
.contact-section {
  margin-bottom: 24px;
}

.contact-card {
  border-radius: 8px;
  padding: 20px;
}

.card-header {
  font-size: 24px;
  font-weight: 500;
  color: #1f2d3d;
  display: flex;
  align-items: center;
}

.card-header .mr-2 {
  margin-right: 8px;
}

.contact-content {
  padding: 15px 0;
  font-size: 18px;
}

.contact-item.with-icon {
  margin-bottom: 12px;
  margin-left: 15px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.contact-label {
  color: #86909c;
  font-weight: 500;
  min-width: 80px;
}

.contact-value {
  color: #1f2d3d;
  flex: 1;
}

/* 需求描述区 */
.description-card {
  border-radius: 8px;
  margin-bottom: 24px;
  padding: 20px;
}

.description-content {
  font-size: 15px;
  line-height: 1.8;
  color: #4e5969;
  padding: 15px 0;
  text-align: justify;
  white-space: pre-line;
  background: #f8f9fa;
  padding: 16px;
  border-radius: 6px;
}

/* 附加信息区 */
.attachment-section {
  margin-bottom: 24px;
}

.attachment-card {
  border-radius: 8px;
  padding: 20px;
}

.attachment-content {
  padding: 15px 0;
}

.attachment-item {
  margin-bottom: 12px;
  font-size: 15px;
  line-height: 1.6;
}

.attachment-label {
  color: #86909c;
  font-weight: 500;
  display: inline-block;
  min-width: 80px;
}

.attachment-value {
  color: #4e5969;
}

/* 返回按钮区 */
.back-section {
  text-align: left;
  margin-top: 10px;
}

/* 响应式适配（与成果详情页保持一致） */
@media screen and (max-width: 768px) {
  .tech-demand-detail {
    max-width: 100%;
    margin: 15px auto;
    padding: 0 15px;
  }

  .detail-content {
    padding: 20px 15px;
  }

  .demand-name {
    font-size: 20px;
  }

  .info-item.with-icon {
    min-width: 100%;
  }
}

@media screen and (max-width: 480px) {
  .demand-name {
    font-size: 18px;
  }

  .info-label {
    min-width: 70px;
  }

  .contact-label, .attachment-label {
    min-width: 70px;
  }
}
</style>